window.pages["nutricao.index"] = {
    init: function () {
        window.components.calculator.init();
    },
};
